import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/XhsProfilePosts.graphql';
import { Query, QueryxhsProfilePostsArgs } from '../../__generated__/globalTypes';

export const useXhsProfilePostsQuery = (options?: QueryHookOptions<Query, QueryxhsProfilePostsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryxhsProfilePostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useXhsProfilePostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryxhsProfilePostsArgs>
): QueryResult<Query, QueryxhsProfilePostsArgs> & {
  getXhsProfilePosts: LazyQueryExecFunction<Query, QueryxhsProfilePostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getXhsProfilePosts, result] = useLazyQuery<Query, QueryxhsProfilePostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getXhsProfilePosts, ...result };
};

export const useXhsProfilePostsPromiseQuery = () => {
  const client = useApolloClient();

  const getXhsProfilePosts = useCallback(
    (options?: Omit<QueryOptions<QueryxhsProfilePostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryxhsProfilePostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getXhsProfilePosts };
};
// Suspense Query Hooks
export const useXhsProfilePostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryxhsProfilePostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryxhsProfilePostsArgs>(QUERY, {
    ...options
  });

  return result;
};
